import React from 'react';
import $ from 'jquery';

const getMeta = name => $(`meta[name="${name}"]`).attr('content');

export const getCsrfParam = () => getMeta('csrf-param');
export const getCsrfToken = () => getMeta('csrf-token');
export const CsrfField = () => (
  <input
    name={getCsrfParam()}
    type="hidden"
    value={getCsrfToken()}
  />
);

const csrfObject = () => ({ [getCsrfParam()]: getCsrfToken() });

export default csrfObject;
